import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"
import { TiDeleteOutline } from "react-icons/ti"

function generateTimestampRandomId() {
  const timestamp = Date.now()
  const randomPart = Math.random().toString(36).substring(2, 15)
  return `id_${timestamp}_${randomPart}`
}

const Autocomplete = ({
  id,
  className,
  label,
  placeholder,
  defaultOptions,
}) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext()
  const optionsSelected = watch(id)

  const handleSelectOption = (value, inputValue, onChange) => {
    if (!inputValue || value.some((item) => item.name === inputValue)) {
      return
    }

    const foundOption = defaultOptions.find(
      (opt) => opt.name === inputValue,
    ) || { id: generateTimestampRandomId(), name: inputValue }
    onChange([...value, foundOption])
  }

  return (
    <Controller
      control={control}
      name={id}
      render={({ field: { value, onChange, onBlur } }) => {
        return (
          <>
            <div
              className={clsx(
                "flex flex-col relative mb-4 w-full",
                className && className,
              )}
            >
              <label
                htmlFor={id}
                className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
              >
                {label}
              </label>
              <input
                type="search"
                list={id}
                placeholder={placeholder || "Type to search"}
                className="bg-gray1 h-8 rounded-lg px-4 text-[12px]"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSelectOption(value, e.target.value, onChange)
                    e.target.value = ""
                  }
                }}
              />
              <div className="absolute top-0">
                <datalist id={id} name={id} className="absolute top-0">
                  {defaultOptions.map((item) => (
                    <option key={item.id} value={item.name} />
                  ))}
                </datalist>
              </div>

              <div className="flex gap-1 mt-2 flex-wrap">
                {value?.map((item) => (
                  <div
                    key={item.id}
                    className="border p-2 rounded-xl bg-[#c8e5e7] flex items-center text-[14px] gap-1 flex-wrap"
                  >
                    {item.name}
                    <button
                      onClick={() => {
                        onChange(value.filter((it) => it.id !== item.id))
                      }}
                    >
                      <TiDeleteOutline className="w-5 h-5" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </>
        )
      }}
    />
  )
}

Autocomplete.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  defaultOptions: PropTypes.array,
}

export default Autocomplete
